import React from "react";

import { cn } from "src/shadcn/lib/utils";

export type IconProp =
  | React.ComponentType<{ className?: string }>
  | string
  | React.ReactElement;

export function renderIcon(icon: IconProp, extraClassName?: string) {
  if (typeof icon === "string") {
    return <i className={cn(icon, extraClassName)} aria-hidden="true" />;
  }

  if (React.isValidElement(icon)) {
    return React.cloneElement(
      icon as React.ReactElement<Record<string, unknown>>,
      {
        "aria-hidden": "true",
        className: cn(
          (icon as React.ReactElement<{ className?: string }>).props.className,
          extraClassName
        ),
      }
    );
  }

  const IconComp = icon as React.ComponentType<{ className?: string }>;
  return <IconComp aria-hidden="true" className={extraClassName} />;
}
